import { FormModel } from '../../../../../components/Form';
import { addonsType } from '../../../../../utils/constants/data';
import { Validators } from '../../../../../utils/validators';
export const AddEditAddOnsForm = (strings: any, addOnCategories: any): FormModel[] => {
  return [
    {
      label: strings.addOn_text_name,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'name',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateString, max: 100 }],
      responsive: { xs: 12, sm: 6, md: 4 },
      required: true,
    },
    {
      label: strings.addOnDescription,
      value: '',
      autoFocus: true,
      type: 'textEditor',
      placeholder: '',
      field: 'description',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, md: 6 },
      required: false,
    },
    {
      label: strings.addOn_text_type,
      value: '',
      size: 'medium',
      type: 'drop-down',
      placeholder: '',
      field: 'addOnType',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, sm: 6, md: 4 },
      required: true,
      options: addonsType(strings) as any,
    },
    {
      label: strings.addOn_text_category,
      value: '',
      size: 'medium',
      type: 'drop-down',
      placeholder: '',
      field: 'addOnCategory',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, sm: 6, md: 4 },
      required: true,
      options: addOnCategories,
    },
    {
      label: strings.addOn_title_maxCount,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: '',
      field: 'maxCount',
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateInt, max: 10000, min: 1 }],
      responsive: { xs: 12, sm: 6, md: 4 },
      required: true,
    },
    {
      label: strings.addOn_text_price,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: '',
      field: 'price',
      inputProps: { min: 0 },
      validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateFloat }],
      responsive: { xs: 12, sm: 6, md: 4 },
      required: true,
    },
    {
      label: strings.addOn_text_taxGroup,
      value: '',
      size: 'medium',
      type: 'select',
      placeholder: strings.addOn_text_taxGroup,
      field: 'taxGroup',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, sm: 6, md: 4 },
      required: true,
      isMulti: false,
      isClearable: false,
    },
    {
      label: strings.addOnHsnCode,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'number',
      placeholder: '',
      field: 'hsnCode',
      validators: [{ check: Validators.validateString, max: 15 }],
      responsive: { xs: 12, sm: 6, md: 4 },
      required: false,
    },
    {
      label: null,
      value: null,
      type: 'section',
      placeholder: '',
      field: null,
      autoFocus: true,
      validators: [],
      required: false,
      responsive: { xs: 12, sm: 12 },
    },
  ];
};
